var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 50,
    viewBox: "0 0 32 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.207 15.0977L15.5273 0L3.84766 15.0977L0 39.9414L15.5273 50L31.0547 39.9414L27.207 15.0977ZM29.5117 36.4258L23.8477 26.3867L26.6211 17.6953L29.5117 36.4258ZM16.2695 2.69531L26.0156 15.293L22.9883 24.8242L16.2695 12.9492V2.69531ZM22.4219 26.5625L18.4375 39.1016H12.6172L8.63281 26.5625L15.5273 14.3359L22.4219 26.5625ZM14.7852 2.69531V12.9492L8.06641 24.8438L5.03906 15.293L14.7852 2.69531ZM4.45312 17.6953L7.22656 26.3867L1.5625 36.4258L4.45312 17.6953ZM7.75391 28.1055L11.25 39.1016H1.5625L7.75391 28.1055ZM2.34375 40.2734H11.6406L14.0625 47.8711L2.34375 40.2734ZM12.9883 40.2734H18.0469L15.5078 48.2422L12.9883 40.2734ZM17.0117 47.8711L19.4336 40.2734H28.7109L17.0117 47.8711ZM19.7852 39.1016L23.2812 28.1055L29.4922 39.1016H19.7852Z",
    fill: "#96A6ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0547,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.9de32798d60026dae6d7ad273599c7a2.svg";
export { ForwardRef as ReactComponent };